var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interface-request-overview"},[_c('card-header',{attrs:{"title":_vm.title}}),_c('div',[(_vm.seriesList.length > 0)?_c('chart-interface-request',_vm._b({attrs:{"seriesList":_vm.seriesList}},'chart-interface-request',_vm.$attrs,false)):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }